/**
 * Tamaño del pentagrama en módulos de aprendizaje (Escalas, Acordes, piano, etc.).
 * PRACTICE_STAFF_GROWTH: +40 % inicial × +30 % adicional = 1.82 sobre la base original.
 */

export const PRACTICE_STAFF_GROWTH = 1.4 * 1.3;

const BASE_STAVE_SCALE = 1.4;
const BASE_GRAND_SCALE = 1.15;
const BASE_CHORD_SCALE = 1.1;

/** Escala VexFlow (líneas del pentagrama + cabezas, palos, plicas/beams, claves). */
export const PRACTICE_STAFF_STAVE_SCALE = BASE_STAVE_SCALE * PRACTICE_STAFF_GROWTH;

/** Gran pentagrama (clave de sol + fa). */
export const PRACTICE_STAFF_GRAND_SCALE = BASE_GRAND_SCALE * PRACTICE_STAFF_GROWTH;

/** Pentagrama compacto de acordes. */
export const PRACTICE_STAFF_CHORD_SCALE = BASE_CHORD_SCALE * PRACTICE_STAFF_GROWTH;

/** Modo exploratorio Acordes: pentagrama más alto para ver clave y plicas completas. */
export const PRACTICE_STAFF_CHORD_EXPLORER_BOOST = 1.32;

export const PRACTICE_STAFF_HEIGHT_TREBLE = Math.round(180 * PRACTICE_STAFF_GROWTH);
export const PRACTICE_STAFF_HEIGHT_GRAND_LIGHT = Math.round(220 * PRACTICE_STAFF_GROWTH);
export const PRACTICE_STAFF_HEIGHT_GRAND_DARK = Math.round(200 * PRACTICE_STAFF_GROWTH);
export const PRACTICE_STAFF_HEIGHT_CHORD = Math.round(
  118 * PRACTICE_STAFF_GROWTH * PRACTICE_STAFF_CHORD_EXPLORER_BOOST
);

export const PRACTICE_STAFF_MIN_GRAND_LIGHT = Math.round(200 * PRACTICE_STAFF_GROWTH);
export const PRACTICE_STAFF_MIN_GRAND_DARK = Math.round(180 * PRACTICE_STAFF_GROWTH);
export const PRACTICE_STAFF_MIN_CHORD = Math.round(
  118 * PRACTICE_STAFF_GROWTH * PRACTICE_STAFF_CHORD_EXPLORER_BOOST
);
export const PRACTICE_STAFF_MIN_SCALE_KEYBOARD = Math.round(140 * PRACTICE_STAFF_GROWTH);
